export const state = () => ({
    selectEntities: {},
    Result:'',
    relatedEntities: []
})